import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiEmbeddedTaxForm' })(
  ({ brandType, brandColors, breakpoints, type, typography }) => ({
    embeddedLeadForm: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      maxWidth: typography.pxToRem(448),
      marginRight: typography.pxToRem(48),
      marginLeft: typography.pxToRem(45),
      backgroundColor: brandColors.white,
      paddingTop: typography.pxToRem(39),
      paddingBottom: typography.pxToRem(45),
      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        filter: 'none',
      },
    },
    title: {
      ...type['28_medium'],
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['24_medium'],
      },
    },
    subtitle: {
      ...type['20_regular'],
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(39),
      paddingBottom: typography.pxToRem(18),
      marginBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
        paddingBottom: typography.pxToRem(16),
        marginBottom: typography.pxToRem(16),
      },
    },
    progressCircle: {
      display: 'flex',
      marginRight: typography.pxToRem(25),
      width: typography.pxToRem(60),
      height: typography.pxToRem(60),
      borderRadius: typography.pxToRem(60),
      backgroundColor: brandColors.primaryMain,
      opacity: 0.4,
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
    },
    progressCircleSection: {
      display: 'flex',
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(39),
      marginBottom: typography.pxToRem(34),
    },
    progressCircleSelected: {
      opacity: 1,
    },
    bar: {
      width: typography.pxToRem(70),
      height: typography.pxToRem(128),
      paddingLeft: typography.pxToRem(12),
      paddingRight: typography.pxToRem(12),
      marginRight: typography.pxToRem(10),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingBottom: typography.pxToRem(25),
    },
    percentIndicator: {
      width: '100%',
      backgroundColor: brandColors.chargeBlue,
    },
    barGraph: {
      display: 'flex',
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(39),
      paddingBottom: typography.pxToRem(20),
      marginBottom: typography.pxToRem(20),
    },
    barTitle: {
      fontWeight: 500,
      fontSize: typography.pxToRem(28),
      lineHeight: typography.pxToRem(36),
      letterSpacing: '-0.02em',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['20_regular'],
      },
    },
    barSubtitle: {
      fontWeight: 500,
      fontSize: typography.pxToRem(12),
      lineHeight: typography.pxToRem(15),
      letterSpacing: '-0.02em',
    },
    divider: {
      borderBottom: '0.5px solid black',
    },
    cta: {
      ...type['28_medium'],
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(39),
      marginBottom: typography.pxToRem(30),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['24_medium'],
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(39),
    },
    formLabel: {
      marginBottom: typography.pxToRem(11),
      ...type['20_regular'],
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    radioRow: {
      ...type['20_regular'],
      borderBottom: '0.5px solid black',
      paddingBottom: typography.pxToRem(20),
      marginBottom: typography.pxToRem(20),
      display: 'flex',
    },
    radioLabel: {
      ...type['20_regular'],
      marginLeft: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    select: {
      height: typography.pxToRem(41),
      marginBottom: typography.pxToRem(34),
      paddingLeft: typography.pxToRem(16),
      paddingRight: typography.pxToRem(16),
    },
    checkboxRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: typography.pxToRem(10),
    },
    checkboxLabel: {
      ...type['16_medium'],
      marginLeft: typography.pxToRem(20),
    },
    tos: {
      ...brandType['body-s'],
      fontSize: typography.pxToRem(12),
      marginTop: typography.pxToRem(20),
      marginBottom: typography.pxToRem(20),
      '& p': {
        ...brandType['body-s'],
      },
    },
    submissionContent: {
      paddingLeft: typography.pxToRem(39),
      paddingRight: typography.pxToRem(39),
      paddingTop: typography.pxToRem(21),
      '& button': {
        width: 'auto',
        padding: '0 1rem',
      },
    },
    submissionTitle: {
      ...type['28_medium'],
      marginBottom: typography.pxToRem(65),
    },
    submissionImage: {
      width: '100%',
      marginTop: typography.pxToRem(28),
      marginBottom: typography.pxToRem(40),
    },
    error: {
      marginTop: typography.pxToRem(10),
      height: typography.pxToRem(16),
      color: brandColors.errorMain,
      ...brandType['body-s'],
    },
    hidden: {
      display: 'none',
    },
  })
);

export default useStyles;
